import { useFetchRegistrationQuery } from "../../redux/api/registration";
import { useFetchTeOrganizationQuery } from "../../redux/api/te";
import { useMapping, useUserData } from "../../redux/hooks";
import { RegistrationLoadingSpinner } from "@timeedit/registration-components";
import { RegistrationError } from "@timeedit/registration-shared";
import { Outlet } from "react-router-dom";
import "./rootPage.scss";
import { useMemo } from "react";
import { useDetectBreadcrumbs } from "../../hooks/useDetectBreadcrumbs";
import { Content } from "@timeedit/ui-components/antd/layout/layout";
import { useIsHub } from "./HubLayoutContext";

export function PageOutlet(): React.JSX.Element {
  const user = useUserData();
  const org = useFetchTeOrganizationQuery(
    { organizationId: user.data?.organizationId },
    { skip: user.isLoading || user.isError }
  );
  const mapping = useMapping({ init: true });
  const registration = useFetchRegistrationQuery();

  const isLoading =
    mapping.isLoading ||
    mapping.isFetching ||
    org.isLoading ||
    user.isLoading ||
    registration.isLoading;

  const { courses, activities } = useMemo(
    () =>
      !isLoading && registration.data
        ? registration.data
        : { courses: {}, activities: {} },
    [isLoading, registration.data]
  );

  const isHub = useIsHub();

  useDetectBreadcrumbs({ courses, activities });

  if (isLoading) {
    return <RegistrationLoadingSpinner />;
  }

  if (mapping.isError) {
    throw new RegistrationError({ errors: mapping.error });
  }

  if (isHub) {
    return <Outlet />;
  }

  return (
    <Content className="root-page__content" id={"main"}>
      <div className="root-page__outlet">
        <Outlet />
      </div>
    </Content>
  );
}
